export function search() {
    const searchToggles = document.querySelectorAll('.js-search-control');

    if (searchToggles) {
        searchToggles.forEach((toggle) => {
            toggle.addEventListener('click', handleSearchToggle);
        });
    }
}

function handleSearchToggle(e) {
    const target = e.currentTarget;
    const icon = target.querySelector('.js-search-control-icon');
    const controlsId = target.getAttribute('aria-controls');
    const searchContainer = document.getElementById(controlsId);

    if (!searchContainer) {
        return;
    }

    const isPressed = target.getAttribute('aria-pressed') === 'true';
    const label = searchContainer.querySelector('label');
    const searchInput = searchContainer.querySelector('input');
    const searchAutocomplete = document.querySelector('.search-autocomplete');

    if (isPressed) {
        searchContainer.style.height = null;
        searchAutocomplete.setAttribute('data-active', false);
        searchContainer.setAttribute('data-active', false);
        target.setAttribute('aria-pressed', 'false');
        icon.innerHTML = '<i class="fal fa-search"></i>';

        if (label) {
            searchInput.removeEventListener('keyup', handleSearchKeyup);
        }

        return;
    }

    const searchContainerContents = searchContainer.querySelector('.js-search-container-contents');
    searchContainer.style.height = `${searchContainerContents.offsetHeight}px`;
    searchContainer.setAttribute('data-active', true);

    jQuery('.nav-link.dropdown-toggle.show').removeClass('show');

    target.setAttribute('aria-pressed', 'true');
    searchInput && searchInput.focus() && searchInput.select();
    icon.innerHTML = '<i class="fal fa-times"></i>';

    searchAutocomplete.style.top = searchContainer.offsetTop + searchContainerContents.offsetHeight + 'px';
    setTimeout(function () {
        searchAutocomplete.setAttribute('data-active', true);
    }, 250);

    if (label) {
        searchInput.addEventListener('keyup', handleSearchKeyup);
        if (searchInput?.value?.length) {
            // in case of reopening or opening initially on search results page
            label.classList.add('is-floating');
        }
    }
    return;
}

function handleSearchKeyup(e) {
    const input = e.currentTarget;
    const label = input.nextElementSibling;

    if (input?.value?.length) {
        label.classList.add('is-floating');
    } else {
        label.classList.remove('is-floating');
    }

    return;
}

jQuery(document).ready(function ($) {
    var timeout = null;

    $('#ct_navigation-search #s').keyup(function () {
        var search = $(this).val();

        if (search != '') {
            const searchAutocompleteUl = document.querySelector('.search-autocomplete ul');
            searchAutocompleteUl.innerHTML = '';

            if (timeout) {
                clearTimeout(timeout);
            }
            timeout = setTimeout(function () {
                $.ajax({
                    url: $('#ct_navigation-search').data('ajax') + search,
                    type: 'get',
                    dataType: 'json',
                    success: function (response) {
                        searchAutocompleteUl.innerHTML = '';
                        if (response.success) {
                            for (var i = 0; i < response['data'].length; i++) {
                                searchAutocompleteUl.innerHTML =
                                    searchAutocompleteUl.innerHTML +
                                    '<li data-term="' +
                                    response['data'][i]['term'] +
                                    '">' +
                                    response['data'][i]['term'] +
                                    '</li>';
                            }

                            $('.search-autocomplete li').bind('click', function () {
                                var term = $(this).attr('data-term');
                                var searchInput = document.querySelector('#ct_navigation-search #s');
                                searchInput.value = term;

                                $('form#searchform').submit();
                            });
                        }
                    },
                });
            }, 250);
        }
    });
});
